import Interval from "./Interval";

const DatePicker = { Interval };

export default DatePicker;
